import {makeStyles} from "@material-ui/styles";
import {ChevronRight} from "@material-ui/icons";
import {
    Button,
    TextField,
    Chip,
    CircularProgress,
    Accordion,
    AccordionSummary,
    Typography,
    AccordionDetails,
} from '@material-ui/core';
import {Alert, AlertTitle} from "@material-ui/lab";
import {getCMSSettings} from "tools/cmsBlockSettings";
import {useContext, useEffect, useState} from "react";
import fetch from "react-storefront/fetch";
import {useTranslation} from "tools/i18n";
import { ErrorContext } from "../../../providers/error";
import useSessionStore from '@services/stores/SessionStore';
import ExpandMore from '@icons/expand_more_light.svg';
import ProductBundle from '@components/page/product/partial/ProductBundle';

const useStyles = makeStyles((theme) => {
    return {
        wrapper: {
            border: '1px solid #c4c4c4',
            borderLeft: 'none',
            borderRight: 'none',
            padding: '0 4em',
            margin: '2em -17px',
            marginTop: -1,
            [theme.breakpoints.up('lg')]: {
                margin: '1em 0',
                padding: '0 0.5em',
                marginTop: -1,
            },
            [theme.breakpoints.down('sm')]: {
                padding: '0 1em',
                marginTop: -1,
                margin: '2em -14px',
            },
        },
        accordion: {
            width: '100%',
            boxShadow: 'none',
            backgroundColor: theme.palette.primary.background,
            color: theme.palette.primary.color,
            '&:before': {
                display: 'none'
            },
            [theme.breakpoints.down('sm')]: {
                backgroundColor: theme.palette.primary.background
            },

        },
        accordionExpanded: {
            margin: '0 0 25px 0 !important'
        },
        summary: {
            margin: '0 !important',
            padding: '0 0',
            minHeight: '0px !important',
            [theme.breakpoints.up('sm')]: {
                padding: '0 0',
                marginBottom: '0 !important'
            }
        },
        summaryContent: {
            margin: 0,
            padding: '15px 0',
            [theme.breakpoints.up('sm')]: {
                padding: '20px 0',
            }
        },
        detailsRoot: {
            display: 'flex',
            flexDirection: 'column',
            padding: 0,
            '& p': {
                textAlign: 'left',
                maxWidth: '65ch',
                marginTop: 0,
            }
        },
        summaryText: {
            fontSize: 15,
            fontWeight: 300,
            letterSpacing: 0,
            color: theme.palette.primary.color,
            textTransform: 'uppercase',
            [theme.breakpoints.down('sm')]: {
                fontSize: 14
            }
        },
        summaryIcon: {
            height: 28,
            padding: 0,
            marginRight: 0,
            '& svg': {
                transform: 'scale(0.8)',
                fill: '#aaa'
            }
        },
    }
}, {name: 'CampaignTerms'});

export default function CampaignTerms({block}) {
    const classes = useStyles();
    const {t} = useTranslation(['support', 'popup']);
	const { title, text } = block?.slots?.[0]?.translated?.config;
    const [accordionOpen, setAccordionOpen] = useState(false)

    return (
        <div className={classes.wrapper}>
            <Accordion classes={{root: [classes.accordion].join(' '), expanded: classes.accordionExpanded}} square={true} expanded={accordionOpen} onChange={() => setAccordionOpen(!accordionOpen)}>
                <AccordionSummary classes={{root: classes.summary, content: classes.summaryContent, expanded: classes.summary, expandIcon: classes.summaryIcon}} expandIcon={<ExpandMore width={48}/>}>
                    <Typography className={classes.summaryText} dangerouslySetInnerHTML={{ __html: title.value || '' }}></Typography>
                </AccordionSummary>
                <AccordionDetails classes={{root: classes.detailsRoot}} dangerouslySetInnerHTML={{ __html: text.value || '' }}></AccordionDetails>
            </Accordion>
        </div>
    );
}
